import {
  MutationAddChecklistArgs,
  MutationDeleteChecklistArgs,
  MutationUpdateChecklistNameArgs,
  MutationUpdateChecklistPosArgs,
} from '../../generated';
import {
  prepareDataForApolloCache,
  QueryInfo,
} from '../prepareDataForApolloCache';
import { token } from '@trello/session-cookie';

export const addChecklist = async (
  obj: object,
  args: MutationAddChecklistArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/1/checklists`, {
    method: 'POST',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      idBoard: args.boardId,
      idCard: args.cardId,
      idChecklistSource: args.checklistSourceId || '',
      name: args.name,
      token,
    }),
  });

  const checklist = await response.json();

  checklist.temporaryId = args.temporaryId;

  return prepareDataForApolloCache(checklist, info);
};

export const deleteChecklist = async (
  obj: object,
  args: MutationDeleteChecklistArgs,
  context: object,
  info: QueryInfo,
) => {
  const response = await fetch(`/1/checklists/${args.checklistId}`, {
    method: 'DELETE',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      token,
    }),
  });

  await response.json();

  return prepareDataForApolloCache({ success: true }, info);
};

export const updateChecklistName = async (
  obj: object,
  args: MutationUpdateChecklistNameArgs,
  context: object,
  info: QueryInfo,
) => {
  const params = new URLSearchParams();
  params.set('name', args.name);
  params.set('token', token || '');

  const response = await fetch(`/1/checklists/${args.checklistId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: params,
  });

  const checklist = await response.json();

  return prepareDataForApolloCache(checklist, info);
};

export const updateChecklistPos = async (
  obj: object,
  args: MutationUpdateChecklistPosArgs,
  context: object,
  info: QueryInfo,
) => {
  const params = new URLSearchParams();
  params.set('pos', `${args.pos}`);
  params.set('token', token || '');

  const response = await fetch(`/1/checklists/${args.checklistId}`, {
    method: 'PUT',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    body: params,
  });

  const checklist = await response.json();

  return prepareDataForApolloCache(checklist, info);
};
